import {useFeatureGate} from '@amzn/showtime';

// For more info on feature access via PopStar, see
// https://evergreen.corp.amazon.com/atoz-developer-program/develop/feature_access/popstar/

export const ATOZ_ALUMNI_SALARIED_JOBS_FEATURE_ID = 'alumni_jobs_salaried_tab';
export const HVH_CAREERS_ATOZ_HVH_APP_REDIRECT = 'hvh_career_atoz_hvh_app_redirect';
export const HVH_CAREERS_ATOZ_HVH_APP_ACCOUNT_MATCH_AES_REDIRECT = 'hvh_career_atoz_hvh_app_account_match_aes_redirect';
export const HVH_CAREERS_INGRESS_POINT_FEATURE_ID = 'hvh_career_site_ingress_point';
export const HVH_CAREERS_JOB_DETAIL_FEATURE_ID = 'hvh_career_job_detail';
export const HVH_CAREERS_JOB_DETAIL_MATCH_FEATURE_ID = 'hvh_career_job_detail_match';
export const HVH_CAREERS_LOAD_MORE_FEATURE_ID = 'hvh_career_load_more';
export const HVH_CAREERS_REVERSE_PROXY_MIGRATION_FEATURE_ID = 'proxy_migration_hvh_career';
export const AtoZ_HVH_APP_FEATURE_ID = 'atoz_hvh_app_feature';
export const HVH_CAREERS_UK_PHASE3_FEATURE_ID = 'hvh_career_site_uk_phase3';
export const HVH_CAREERS_ATOZ_PREFERENCE_CENTER_FEATURE_ID = 'hvh_career_atoz_preference_center';
export const HVH_CAREERS_JOB_SEARCH_NATIVE_TO_WEB = 'hvh_career_job_search_native_to_web';

const hasFeature = (features: string[], feature: string) => features.includes(feature);

export const hasHVHCareersFeature = (features: string[]) => hasFeature(features, HVH_CAREERS_INGRESS_POINT_FEATURE_ID);
export const hasHVHCareersJobDetail = (features: string[]) => hasFeature(features, HVH_CAREERS_JOB_DETAIL_FEATURE_ID);
export const hasHVHCareersLoadMore = (features: string[]) => hasFeature(features, HVH_CAREERS_LOAD_MORE_FEATURE_ID);
export const hasSalariedAlumniJobs = (features: string[]) => hasFeature(features, ATOZ_ALUMNI_SALARIED_JOBS_FEATURE_ID);
export const hasAtoZHVHAppFeature = (features: string[]) => hasFeature(features, AtoZ_HVH_APP_FEATURE_ID);
export const hasHVHCareersUKPhase3Feature = (features: string[]) =>
  hasFeature(features, HVH_CAREERS_UK_PHASE3_FEATURE_ID);
export const hasHVHCareersAtoZPreferenceCenter = (features: string[]) =>
  hasFeature(features, HVH_CAREERS_ATOZ_PREFERENCE_CENTER_FEATURE_ID);
export const hasJobSearchNativeToWeb = (features: string[]) =>
  hasFeature(features, HVH_CAREERS_JOB_SEARCH_NATIVE_TO_WEB);

export const useIsAccountMatchPageEnabled = () => useFeatureGate(HVH_CAREERS_JOB_DETAIL_MATCH_FEATURE_ID);
export const useIsAtoZHVHAppRedirectEnabled = () => useFeatureGate(HVH_CAREERS_ATOZ_HVH_APP_REDIRECT);
export const useIsAtoZHVHAppAccountMatchAESRedirectEnabled = () =>
  useFeatureGate(HVH_CAREERS_ATOZ_HVH_APP_ACCOUNT_MATCH_AES_REDIRECT);
export const useIsJobDetailPageEnabled = () => useFeatureGate(HVH_CAREERS_JOB_DETAIL_FEATURE_ID);
export const useIsLoadMoreFeatureEnabled = () => useFeatureGate(HVH_CAREERS_LOAD_MORE_FEATURE_ID);
export const useIsReverseProxyEnabled = () => useFeatureGate(HVH_CAREERS_REVERSE_PROXY_MIGRATION_FEATURE_ID);
